export const RIGHT_COLUMN_BREAKPOINT = 1000;
